package games.polyclub.website.frontend.store.pages

import games.polyclub.frontend.lib.react.bootstrap.components.Card
import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.h2
import games.polyclub.frontend.lib.react.simplified.tags.li
import games.polyclub.frontend.lib.react.simplified.tags.p
import games.polyclub.frontend.lib.react.simplified.tags.ul
import games.polyclub.message.unaryMinus
import games.polyclub.website.frontend.store.context.addBreadcrumb
import games.polyclub.website.frontend.store.layout.PageBody
import games.polyclub.website.frontend.store.layout.PageHeader
import games.polyclub.website.frontend.store.sitemap.PublicSitemap
import react.Props

val TermsPage = SFC<Props> { _ ->
    addBreadcrumb(PublicSitemap.TERMS.pathPart, -"Termos de Uso")

    PageHeader {
        title = -"Termos de Uso da PolyClub"
    }
    PageBody {
        Card {
            h2 {
                +"1. Introdução"
            }
            p {
                +"Bem-vindo à PolyClub, sua loja online de produtos digitais exclusivos para servidores de Minecraft, sites e a nossa guild do Discord. A PolyClub é operada sob a razão social \"29.264.563 Polyana Fontes\", com CNPJ 29.264.563/0001-79, sediada no Brasil. Ao acessar e utilizar nossos serviços, você concorda em cumprir os termos e condições descritos abaixo. Leia atentamente os seguintes termos de uso:"
            }

            h2 {
                +"2. Produtos Digitais"
            }
            p {
                +"A PolyClub oferece produtos digitais, como acesso a servidores de Minecraft exclusivos, cosméticos e produtos virtuais para serem utilizados em nossos servidores. Ao adquirir e utilizar esses produtos, você concorda em usá-los exclusivamente conforme as diretrizes e regras estabelecidas pelos respectivos serviços."
            }

            h2 {
                +"3. Responsabilidades do Usuário"
            }
            p {
                +"Ao utilizar a PolyClub, você concorda em:"
            }
            ul {
                li {
                    +"Respeitar todas as leis e regulamentações aplicáveis, bem como os termos de uso dos serviços em que nossos produtos são utilizados."
                }
                li {
                    +"Não compartilhar, revender ou distribuir os produtos da PolyClub sem autorização prévia."
                }
                li {
                    +"Manter sua conta e informações pessoais seguras e atualizadas."
                }
            }

            h2 {
                +"4. Vendas e Entrega"
            }
            p {
                +"A PolyClub opera nos domínios polyclub.games e gamemods.com.br. Ao efetuar uma compra em nossa loja, você concorda em fornecer informações precisas e válidas."
            }
            p {
                +"Após a confirmação de pagamento, você terá acesso aos produtos digitais adquiridos. Certifique-se de seguir as instruções de uso fornecidas com cada produto."
            }

            h2 {
                +"5. Direitos Autorais"
            }
            p {
                +"Todos os produtos digitais oferecidos pela PolyClub são protegidos por direitos autorais. Qualquer uso não autorizado, reprodução ou distribuição desses produtos é estritamente proibido."
            }

            h2 {
                +"6. Jurisdição e Leis Aplicáveis"
            }
            p {
                +"A PolyClub está sediada no Brasil e opera de acordo com as leis brasileiras. Quaisquer disputas ou litígios serão regidos pelas leis brasileiras."
            }

            h2 {
                +"7. Alterações nos Termos de Uso"
            }
            p {
                +"A PolyClub se reserva o direito de alterar, modificar ou atualizar estes termos de uso a qualquer momento. As alterações serão comunicadas por meio do nosso site. Recomendamos que você verifique regularmente os termos de uso para se manter informado sobre quaisquer atualizações."
            }

            h2 {
                +"8. Contato"
            }
            p {
                +"Para entrar em contato com a PolyClub em relação a dúvidas, problemas ou informações gerais, você pode fazê-lo por meio dos canais de suporte fornecidos em nosso site."
            }

            p {
                +"Ao utilizar a PolyClub e adquirir nossos produtos, você concorda com estes termos de uso. Se você não concordar com qualquer parte destes termos, recomendamos que não utilize nossos serviços. O não cumprimento destes termos pode resultar em medidas disciplinares, incluindo a suspensão ou encerramento da sua conta."
            }

            p {
                +"Agradecemos por escolher a PolyClub como sua loja de produtos digitais exclusivos."
            }
        }
    }
}
